import {
  UPDATE_SALES_INVOICE_PAYMENT,
  UPDATE_SALES_INVOICE_PAYMENT_SUCCESS,
  UPDATE_SALES_INVOICE_PAYMENT_FAILURE,
  RESET_SALES_INVOICE_PAYMENT,
} from '../actions/type';

const INITIAL_STATE = {
  updatedSalesInvoicePayment: null,
  updateSalesInvoicePaymentError: null,
  salesInvoicePaymentIsUpdating: false,
  salesInvoicePaymentUpdated: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_SALES_INVOICE_PAYMENT:
      return {
        ...state,
        updatedSalesInvoicePayment: null,
        updateSalesInvoicePaymentError: null,
        salesInvoicePaymentIsUpdating: true,
        salesInvoicePaymentUpdated: false,
      };
    case UPDATE_SALES_INVOICE_PAYMENT_SUCCESS:
      return {
        ...state,
        updatedSalesInvoicePayment: action.payload.data,
        updateSalesInvoicePaymentError: null,
        salesInvoicePaymentIsUpdating: false,
        salesInvoicePaymentUpdated: true,
      };
    case UPDATE_SALES_INVOICE_PAYMENT_FAILURE:
      const updateSalesInvoicePaymentError = action.payload || { message: action.payload.message };
      return {
        ...state,
        updatedSalesInvoicePayment: null,
        updateSalesInvoicePaymentError,
        salesInvoicePaymentIsUpdating: false,
        salesInvoicePaymentUpdated: false,
      };
    case RESET_SALES_INVOICE_PAYMENT:
      return {
        ...state,
        updatedSalesInvoicePayment: null,
        updateSalesInvoicePaymentError: null,
        salesInvoicePaymentIsUpdating: false,
        salesInvoicePaymentUpdated: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/salesInvoicePayment_reducer.jsx